import styled from '@emotion/styled';
import { Box } from './box';

export const MonoText = styled(Box)`
  font-family: monospace;
`;

MonoText.defaultProps = {
  as: 'p',
};
